import { useModal } from '@trinity/chat-components/components/Modal';
import { RenameFolderModal } from '../Modal.RenameFolder';

export const useRenameFolderModal = () => {
  return useModal(RenameFolderModal);
};